import type {Theme, ThemeAndAnyColor, WithThemeProp} from '../theme';

import {getInByToken} from '../../utils/object';

/**
 * Utility to get color from the theme by token
 * OR any valid color if color IS NOT a theme token
 * inside the css`` or styled`` template literal.
 *
 * @param color
 */
export const getColor =
  (color?: ThemeAndAnyColor) =>
  <ComponentProps extends WithThemeProp>(p: ComponentProps) => {
    if (color) {
      let themeColor = getInByToken<Theme['color']['v3']>(
        p.theme.color.v3,
        color,
      );

      if (!themeColor) {
        themeColor = getInByToken<Theme['color']['v2']>(
          p.theme.color.v2,
          color,
        );
      }

      return themeColor ?? color;
    }

    // eslint-disable-next-line no-console
    console.warn('color is not defined');

    return undefined;
  };
